import queryString from "querystring";
import { removeQueryStrings } from "lib/browser-hacks";

interface TestBehaviors {
    readonly bypassAppLock: boolean;
    readonly disableAppSaver: boolean;
    readonly showSaveState: boolean;
}

let testBehaviors: TestBehaviors = {
    bypassAppLock: false,
    disableAppSaver: false,
    showSaveState: false,
};

let checked = false;
export function getTestBehaviors(): TestBehaviors {
    if (!checked) {
        checkForTestMode();
        checked = true;
    }
    return testBehaviors;
}

function setTestMode(param: string) {
    if (param.toLowerCase() === "bypassonly") {
        testBehaviors = {
            bypassAppLock: true,
            disableAppSaver: false,
            showSaveState: true,
        };
    } else {
        testBehaviors = {
            bypassAppLock: true,
            disableAppSaver: true,
            showSaveState: true,
        };
    }

    (window as any).setFeatureFlagDebugPrint(true);
    (window as any).setFeatureFlagDebugBrowserReload(true);
}

function checkForTestMode() {
    const queryStringParsed = queryString.parse(window.location.search.substr(1));

    const { testMode } = queryStringParsed;

    if (testMode !== undefined) {
        setTestMode(testMode as string);
    }

    removeQueryStrings("testMode");
}
